import templateUrl from './admins-by-category-pie.html';

export default {
  templateUrl,
  controller: class AdministrationsByCategoryPieComponent {
    constructor($scope, LoadingService, AdminsByCategoryPieService, ToastService) {
      'ngInject';

      Object.assign(this, {
        $scope,
        LoadingService,
        AdminsByCategoryPieService,
        ToastService
      });
    }

    getChartConfig() {
      return {
        title: {
          text: 'Administrations by Product Category'
        },
        subtitle: {
          text: 'NASC Adverse Event Reporting System'
        },
        xAxis: {
          type: 'category'
        },
        yAxis: {
          title: {
            text: 'Administrations (in mils)'
          }
        },
        legend: {
          itemWidth: 180,
          itemDistance: 0,
          itemStyle: {
            fontSize: '14px'
          }
        },
        plotOptions: {
          pie: {
            size: 500,
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: true,
              format: '{point.name}: {point.percentage:.1f}%',
              style: {
                fontSize: '14px'
              }
            },
            showInLegend: true
          }
        },
        tooltip: {
          headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
          pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:,.2f} mil</b></td></tr>',
          footerFormat: '</table>',
          shared: true,
          useHTML: true
        }
      };
    }

    $onInit() {
      this.chartConfig = this.getChartConfig();
    }

    generateReport({ params }) {
      this.LoadingService.start();
      this.AdminsByCategoryPieService.getReport(params)
        .then(({ series, drilldown }) => {
          this.chartConfig = undefined;
          this.$scope.$apply();
          this.chartConfig = {
            ...this.getChartConfig(),
            series,
            drilldown
          };
        }).catch(error => this.ToastService.showError(error))
      .finally(() => {
        this.LoadingService.stop();
        this.$scope.$apply();
      });
    }
  }
};



// WEBPACK FOOTER //
// ./components/app/reports/admins-by-category-pie/admins-by-category-pie.component.js